import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { ConfigState, KindeConfig, SiteInfo, SiteConfig } from "./types";

const initialState: ConfigState = {
  config: undefined,
  siteInfo: {} as SiteInfo,
};

export const configSlice = createSlice({
  name: "config",
  initialState,
  reducers: {
    setConfig: (state, { payload }: PayloadAction<SiteConfig | undefined>) => {
      state.config = payload;
    },
    setSiteInfo: (state, action: PayloadAction<SiteInfo>) => {
      state.siteInfo = action.payload;
    },
    setKindeConfig: (state, action: PayloadAction<KindeConfig>) => {
      state.kindeConfig = action.payload;
    },
  },
});

export default configSlice.reducer;
export const { setConfig, setSiteInfo, setKindeConfig } = configSlice.actions;
